import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { Plugins } from "@capacitor/core";
import store from "@/store/store";
import { StorageService, StorageKeys } from "../../services/Storage";
import PlatformService from "../../services/Platform";
import FeatureService from "../../services/Feature";
import LocationModelService from "../../services/LocationModel";
import { haversineDistance } from "../../util";

export default async (to, from, next) => {
  let canShowIntro =
    FeatureService.shouldShowAppIntroScreen() && PlatformService.isMobile();
  let hasSeenIntro =
    StorageService.get(StorageKeys.HAS_SEEN_APP_INTRO) ||
    PlatformService.isWeb();
  let currentUser = firebase.auth().currentUser;

  if (currentUser || store.state.auth.skipSignUp) {
    if (PlatformService.isWeb()) {
      next({
        name: "Web: Order Dashboard"
      });
    } else {
      if (store.state.order.location) {
        // This seems like it would be a bug if they somehow got here, because there's
        // no ability to click, and if you reload the page by changing the URL somehow
        // vuex will be unset anyway
        next({ name: "App: Location Menu" });
      } else {
        // get locations (I realize that this is not 'cached' so this isn't so great, but locations are small (currently))
        let q = LocationModelService.acceptingOrdersQuery();
        let querySnapshot = await q.get();

        if (querySnapshot.size === 1) {
          let location = querySnapshot.docs[0].data();
          store.commit("order/setOrderLocation", location);
          next({ name: "App: Location Menu" });
        } else {
          if (FeatureService.hasGPSAccess()) {
            // mixing in this is bad practice, so don't copy this! :(
            const loading = document.createElement("ion-loading");
            loading.cssClass = "my-custom-class";
            loading.message = "Finding closest location...";
            document.body.appendChild(loading);
            await loading.present();

            const { Geolocation } = Plugins;

            try {
              let geolocationPosition = await Geolocation.getCurrentPosition();
              const { latitude, longitude } = geolocationPosition.coords;
              let unsortedLocations = [];

              querySnapshot.forEach(l => {
                let location = l.data();
                location.distanceToCurrentLocation = haversineDistance(
                  latitude,
                  longitude,
                  location.geoPoint.latitude,
                  location.geoPoint.longitude
                );
                unsortedLocations.push(location);
              });

              const sortedLocations = unsortedLocations.sort(
                (a, b) =>
                  a.distanceToCurrentLocation - b.distanceToCurrentLocation
              );

              store.commit("order/setOrderLocation", sortedLocations[0]);
              loading.dismiss();
              next({ name: "App: Location Menu" });
            } catch (e) {
              loading.dismiss();
              next({ name: "App: Locations" });
            }
          } else {
            next({ name: "App: Locations" });
          }
        }
      }
    }
  } else if (hasSeenIntro) {
    next({ name: "Sign In" });
  } else if (canShowIntro) {
    next({ name: "App: Intro" });
  } else {
    next({ name: "Sign Up" });
  }
};
